export const appEntries = [
  {
    id: "android",
    platform: "安卓 Android",
    icon: "ri-android-line",
    version: "v3.2.1",
    size: "约 28 MB",
    requirement: "Android 7.0 及以上",
    note: "安装包通过最新可用地址页面内的APP入口获取。安装前需在系统设置中允许安装未知来源应用，安装完成后即可离线打开。",
    steps: ["打开本文任一最新可用地址", "在页面内找到APP下载入口", "下载安装包并完成安装"],
  },
  {
    id: "ios",
    platform: "苹果 iOS",
    icon: "ri-apple-line",
    version: "v3.2.0",
    size: "约 62 MB",
    requirement: "iOS 13.0 及以上",
    note: "使用 Safari 浏览器打开入口页后按提示安装。安装完成后如无法直接打开，需前往「设置 - 通用 - VPN与设备管理」信任对应描述文件。",
    steps: ["用 Safari 打开最新可用地址", "按页面提示安装并信任描述文件", "返回桌面点击图标启动"],
  },
  {
    id: "pc",
    platform: "电脑端",
    icon: "ri-computer-line",
    version: "无需安装",
    size: "—",
    requirement: "主流桌面浏览器",
    note: "电脑端可直接使用网页版访问，不需要下载任何客户端。大屏观看体验更完整，适合固定场所长期使用。",
    steps: ["复制任一最新可用地址", "粘贴到浏览器地址栏打开", "按 Ctrl+D 收藏方便下次访问"],
  },
  {
    id: "web",
    platform: "网页版 / 免安装",
    icon: "ri-global-line",
    version: "—",
    size: "—",
    requirement: "任意设备",
    note: "临时使用、设备存储不足或不便安装时，直接用网页版即可，核心功能与APP基本一致，无需占用额外空间。",
    steps: ["复制最新地址", "粘贴到任意浏览器打开", "在浏览器菜单中添加到主屏幕"],
  },
];